import { post } from './http'
import global from '@/api/global'

// export function ap (query) {
//   return http({
//     url: 'zwzhbcps/waybill/selectWaybill',
//     method: 'post',
//     data: query,
//     headers: {
//       'content-type': 'application/json;charset=UTF-8'
//     }
//   })
// }
var name = global.stockName
let order = global.orderName
var name1 = global.contractName
var crmServer = global.crmServer
var wmsAccessName = global.wmsAccessName
var wmsStockName = global.wmsStockName
var wmsCenter = global.wmsCenter
var crmServer3 = global.crmServer3
// 新客户名称列表
export let getCustomerlistByTenant = p => {
  if (localStorage.getItem('isCutCrm3') == 1) {
    return post(`${crmServer3}/sCustomer/list`, p)
  } else {
    return post(`/${crmServer}scustomer/getCustomerlistByTenant`, p)
  }
}
export const findContractByhcList = p => post(`/${name1}/contract/findContractByhcList`, p)// 非货主-合同管理
export const findContractByhList = p => post(`/${name1}/contract/findContractByhList`, p) // 货主-合同管理
export const getContractPdfShow = p => post(`/${name1}/api/contractSignature/getContractPdfShow`, p)
// 合同
export const getContractPdfForBusinessNo = p => post(`/${name1}/api/contractSignature/getContractPdfForBusinessNo`, p)
// 库存列表
export const stockProductList = p => post(`/${name}/stockProduct/list`, p)
// 库存转货、提货
export const stockTakeList = p => post(`/${name}/stockProduct/takeList `, p)
// 货物类型
export const dropDownList = p => post(`/${order}/cProductType/dropDownList`, p)
// 地址列表    2023.04.20改 网货地址相关接口换order服务
export const sAddressList = p => post(`/${order}/sAddress/list`, p)
// 新增地址
export const sAddressAdd = p => post(`/${order}/sAddress/add`, p)
// 修改地址
export const sAddressUpdate = p => post(`/${order}/sAddress/update`, p)
// 删除地址
export const sAddressDelete = p => post(`/${order}/sAddress/delete`, p)
// 提单明细
export const sBillList = p => post(`/${name}/sBill/list`, p)
// 提单明细修改
export const sBillUpdate = p => post(`/${name}/sBill/update`, p)
// 提单明撤回
export const sBillDelete = p => post(`/${name}/sBill/delete`, p)
// 提单提交
export const submitSBill = p => post(`/${name}/sBill/submitSBill`, p)
// 提单明细详情
export const sBillWayProductList = p => post(`/${name}/sBillWayProduct/sBillWayProductListDetail`, p)
// 发布货源/自提功能
export const sBillAdd = p => post(`/${name}/sBill/add`, p)
export const getRelationCustomerFleet = p => post(`/${name}/sBill/getRelationCustomerFleet`, p)
export const getConsignorInfo = p => post(`/${name}/sBill/getConsignorInfo`, p)

// 发布货源/自提功能
export const addFiles = p => post(`/${name}/sBill/pushProduct`, p)
// 转货明细列表
export const sChangeList = p => post(`/${name}/sChange/list`, p)
// 转货明细详情
export const sChangeDetail = p => post(`/${name}/sChange/productDetail`, p)
// 转货明细修改
export const sChangeUpdate = p => post(`/${name}/sChange/update`, p)
// 转货提交
export const submitSChange = p => post(`/${name}/sChange/submitSChange`, p)
// 校验新客户成功
export const getNewCustomer = p => post(`/${name}/sChange/getNewCustomer`, p)
// 转货撤回
export const cancelChangeProduct = p => post(`/${name}/sChange/cancelChangeProduct`, p)
// 转货确定
export const transferGoods = p => post(`/${name}/sChange/transferGoods`, p)
// 所在仓库列表
export const warehouseList = p => post(`/${name}/stockProduct/warehouseList`, p)
// 确认密码
export const checkPwd = p => post(`/${name}/user/checkPwd`, p)

// 待办事项列表
export const FALList = p => post(`/${name}/cFlowAuditLog/list`, p)
// 审批跳转页面
export const flowAuditDetail = p => post(`/${name}/cFlowAuditLog/flowAuditDetail`, p)
// 审批 true需要调下一个接口
export const auditFlow = p => post(`/${name}/cFlow/auditFlow`, p)
// 传pdf
export const flowPdf = p => post(`/${name}/cFlow/flowPdf`, p)
// 发送验证码
export const sendSmsCode = p => post(`/${name}/cFlow/sendSmsCode`, p)
// 验证验证码
export const checkSmsCode = p => post(`/${name}/cFlow/checkSmsCode`, p)

// 查看审批进度
export const getAuditCFlow = p => post(`/${name}/cFlowAuditLog/getAuditCFlow`, p)
// 查看转货凭证
export const getSChangeFileUrl = p => post(`/${name}/sChange/getSChangeFileUrl`, p)
// 查看提货凭证
export const getSBillFileUrl = p => post(`/${name}/sBill/getSBillFileUrl`, p)

// 发布货源
export const orderAdd = p => post(`/${order}/sOrder/add`, p)
// 订单列表
export const orderList = p => post(`/${order}/sOrder/list`, p)
// 订单提交
export const submitSOrder = p => post(`/${order}/sOrder/submitSOrder`, p)
// 订单删除
export const orderDel = p => post(`/${order}/sOrder/delete`, p)
// 订单撤回
export const orderRecall = p => post(`/${order}/sOrder/recall`, p)
// 订单详情
export const orderDetail = p => post(`/${order}/sOrder/detail`, p)
// 修改订单
export const orderUpdate = p => post(`/${order}/sOrder/update`, p)
// 售后服务列表
export const sWayAfterSalesList = p => post(`/${order}/sWayAfterSales/list`, p)
// 售后撤回
export const sWayAfterSalesDel = p => post(`/${order}/sWayAfterSales/delete`, p)
// 查看处理结果
export const sWayAfterSalesDetail = p => post(`/${order}/sWayAfterSales/detail`, p)
// 获取服务费率
export const findDictByCode = p => post(`/${order}/sDict/findDictByCode`, p)
// 订单完成
export const manualCompleteOrder = p => post(`/${order}/way/manualCompleteOrder`, p)
// 新版添加提单
export const addBill = p => post(`/${name}/sBill/addBill`, p)
// 新版提单列表
export const billList = p => post(`/${name}/sBill/list`, p)
// 新版提单删除
export const delBill = p => post(`/${name}/sBill/delBill`, p)
// 新版提单详情
export const goodsDetail = p => post(`/${name}/sBillWayProduct/goodsDetail`, p)
// 新版提单提交
export const submitApproval = p => post(`/${name}/sBill/submitApproval`, p)
// 新版提单人车添加
export const sBillCarriageInfoAdd = p => post(`/${name}/sBillCarriageInfo/add`, p)
// 新版提单人车修改
export const sBillCarriageInfoUpdate = p => post(`/${name}/sBillCarriageInfo/update`, p)
// 新版提单人车删除
export const sBillCarriageInfoDel = p => post(`/${name}/sBillCarriageInfo/delete`, p)
// 新版提单人车列表
export const sBillCarriageInfoList = p => post(`/${name}/sBillCarriageInfo/list`, p)
// 新版提单发布
export const pushOrder = p => post(`/${name}/sBill/pushOrder`, p)
// 提货单转转货单
export const billTransferGoods = p => post(`/${name}/sChange/billTransferGoods`, p)
// 青岛钢业基本信息保存
// export const updatePickUpUnit = p => post(`/${name}/sBill/updatePickUpUnit`, p)
// 改版后提货单据编辑（平）
export const saveOrUpdateBill = p => post(`/${name}/sBill/saveOrUpdateBill`, p)
// 改版后提货单据列表（平）
export const childrenList = p => post(`/${name}/sBill/childrenList`, p)
// 查询是否是结算租户(杨野)
export const getDictionaryDetail = p => post(`/${wmsAccessName}/b/dictionary/getDictionaryDetail`, p)
// 结算方式下拉(杨野)
export const feeModeType = p => post(`/${wmsAccessName}/b/dictionary/getDictionary/fee_mode_type`, p)
// 仓储货物类型下拉(杨野)
export const getDictionaryGood = p => post(`/${wmsStockName}/b/dictionary/getDictionary`, p)
export const getDictionaryAll = p => post(`/${wmsStockName}/b/dictionary/getDictionaryAll`, p)
// 入库记录列表(小亚)
export const getInStockCargoRecordList = p => post(`/${wmsCenter}/wmsApi/getInStockCargoRecordList`, p)
// 入库记录统计(小亚)
export const getInWhAllStockInfoCargoListAllWeight = p => post(`/${wmsCenter}/wmsApi/getInWhAllStockInfoCargoListAllWeight`, p)
// 出库记录列表(小亚)
export const getOutStockCargoRecordList = p => post(`/${wmsCenter}/wmsApi/getOutStockCargoRecordList`, p)
// 出库统计(小亚)
export const getOutStockCargoRecordListAllWeight = p => post(`/${wmsCenter}/wmsApi/getOutStockCargoRecordListAllWeight`, p)
// 转货记录列表(小亚)
export const findCustomerChangesList = p => post(`/${wmsCenter}/wmsApi/findCustomerChangesList`, p)
// 转货统计(小亚)
export const getfindCustomerChangesNumber = p => post(`/${wmsCenter}/wmsApi/getfindCustomerChangesNumber`, p)
// 提单撤回（常）
export const sBillRecallBill = p => post(`/${name}/sBill/recallBill`, p)
// 添加人车（平）
export const addBillCarriageInfos = p => post(`/${name}/sBill/addBillCarriageInfos`, p)
// 提货函记录（常）
export const sFileChangeRecordList = p => post(`/${name}/sFileChangeRecord/list`, p)
// 盘库订单
export const getInventoryOrderList = p => post(`/${wmsCenter}/wmsApi/getInventoryOrderList`, p) // 查询
export const getInventoryGoodsList = p => post(`/${wmsCenter}/wmsApi/getInventoryGoodsList`, p) // 货物查询
export const getInventoryPersonList = p => post(`/${wmsCenter}/wmsApi/getInventoryPersonList`, p) // 人员查询
export const deleteNoInventoryOrder = p => post(`/${wmsCenter}/wmsApi/deleteNoInventoryOrder`, p) // 作废
export const deleteInventoryOrder = p => post(`/${wmsCenter}/wmsApi/deleteInventoryOrder`, p) // 删除
export const getVideoUrl = p => post(`/${wmsCenter}/wmsApi/getVideoUrl`, p) // 获取视频
// 卷板盘库新增（杨）
export const getInventoryList = p => post(`/${wmsCenter}/wmsApi/getInventoryList`, p) // 查询
export const getInventoryNumber = p => post(`/${wmsCenter}/wmsApi/getInventoryNumber`, p) // 重量
export const addInventory = p => post(`/${wmsCenter}/wmsApi/addInventory`, p) // 提交盘库
export const findWarehouses = p => post(`/${wmsCenter}/wmsApi/findWarehouses`, p) // 仓位列表
export const getFeeDetailList = p => post(`/${wmsCenter}/wmsApi/getFeeDetailList`, p) // 费用列表
export const finishFee = p => post(`/${wmsCenter}/wmsApi/finishFee`, p) // 费用弹框缴费按钮

// 货主端 找车-发布货源导入(梁)
export const handleProductExcel = p => post(`/${order}/sDemand/handleProductExcel`, p)
// 发布货源-发布(梁)
export const sDemandAdd = p => post(`/${order}/sDemand/add`, p)
// 发布货源-找车服务费(梁)
export const getDemandServiceFee = p => post(`/${order}/sDemand/getDemandServiceFee`, p)
// 长期发布-查询(梁)
export const cyclicPublishDemandList = p => post(`/${order}/sDemand/cyclicPublishDemandList`, p)
// 长期发布-停止发布(梁)
export const stopPublish = p => post(`/${order}/sDemand/stopPublish/${p}`, p)
// 我的竞价-查询(梁)
export const biddingDemandList = p => post(`/${order}/sDemand/biddingDemandList`, p)
// 我的抢单-查询(梁)
export const seckillDemandList = p => post(`/${order}/sDemand/seckillDemandList`, p)
// 长期发布-页面修改发布时间(梁)
export const updateTriggerTimeInfo = p => post(`/${order}/sDemand/updateTriggerTimeInfo`, p)
// 竞价、抢单-作废原因(常)
export const cancelDemand = p => post(`/${order}/sDemand/cancelDemand`, p)
// 查看结果(梁)
export const showBiddingResult = p => post(`/${order}/sDemandOffer/showBiddingResult`, p)
// 货主比价时查看报价列表(梁)
export const getDemandOfferListByDemandId = p => post(`/${order}/sDemandOffer/getDemandOfferListByDemandId`, p)
// 改价记录(常)
export const changePriceRecord = p => post(`/${order}/sDemand/changePriceRecord`, p)
// 比价记录确定(梁)
export const doBiding = p => post(`/${order}/sDemand/doBiding`, p)
// 详情(常)
export const sDemandDetail = p => post(`/${order}/sDemand/detail`, p)
// 找车提货的发布按钮
export const addForFindCar = p => post(`/${name}/sVirtualBill/addForFindCar`, p)
// 找车提货图片上传
export const addSDemandFile = (params, demandId) => post(order + `/s/demand/file/addSDemandFile/${demandId}`, params)
// 找车交易-竞价-作废
export const cancelFindCarTypeEmptyBill = p => post(`/${name}/sVirtualBill/cancelFindCarTypeEmptyBill`, p)
// 找车交易-指派-查询
export const apporintDemandList = p => post(`/${order}/sDemand/apporintDemandList`, p)
// 审核校验库存可提件数
export const checkCustomerAvailableNumber = p => post(`/${name}/cFlow/checkCustomerAvailableNumber`, p)
// 异常记录查询（钱）
export const getExceptionReportingList = p => post(`/${order}/exceptionReporting/getExceptionReportingList`, p)
// 异常记录图片查看（钱）
export const sWayExsReportingPicture = p => post(`/${order}/exceptionReporting/sWayExsReportingPicture`, p)
// 官网海量货源接口（钱）
export const massiveSupplyList = p => post(`/${order}/sOrder/massiveSupplyList`, p)
// 长期货源-新建（平）
export const sPeriodGoodsAdd = p => post(`/${order}/sPeriodGoods/add`, p)
// 长期货源-列表（平）
export const sPeriodGoodsList = p => post(`/${order}/sPeriodGoods/list`, p)
// 长期货源-详情（平）
export const sPeriodGoodsDetail = p => post(`/${order}/sPeriodGoods/detail`, p)
// 长期货源-删除（平）
export const sPeriodGoodsDelete = p => post(`/${order}/sPeriodGoods/delete`, p)
// 长期货源-停启用（平）
export const sPeriodGoodsupdateStatus = p => post(`/${order}/sPeriodGoods/updateStatus`, p)
// 长期货源-己用次数列表（平）
export const sPeriodGoodsPpickList = p => post(`/${order}/sPeriodGoodsPpick/list`, p)
// 货主-订单管理导入（常）
export const impOrder = p => post(`/${order}/sOrder/impOrder`, p)
// 无货权提货-货物导入
export const importProducts = p => post(`/${name}/sBillWayProduct/importProducts`, p)
// 提单管理列表新 20240813
export const findBillList = p => post(`/${name}/sBill/findBillList`, p)
